import '../sass/screen.scss'; // Import SASS for processing

import SimpleParallax from 'simple-parallax-js/vanilla';
import Rellax from 'rellax'; // Import Rellax for inertia scrolling

document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.plax');
  new SimpleParallax(images, {
    scale: 1.3, // optional: how much the image zooms
    delay: 0.6, // optional: delay of the effect
    transition: 'cubic-bezier(0,0,0,1)' // optional: easing
  });
});



let slickSlider;


jQuery(document).ready(function($) {



    $('#nav-toggle').click(function(){
        $('body').toggleClass('m-toggle');
    });   


  
  

    // -- header height
    const header = document.querySelector('.header');

    const getHeaderHeight = () => {

        // -- set timeout to allow for the header to render
        setTimeout(function() { 
        
            let headerHeight = header.offsetHeight;
    
            document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');
    
        }, 500);
    
    };

    getHeaderHeight();

    // -- resize event
    window.addEventListener('resize', getHeaderHeight);



    // -- testislider 

    // -- slick slider
     slickSlider = $('.testimonials__slider');
    if (slickSlider.length) {

        slickSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            arrows: true,
            fade: true,
            prevArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-left-long'></i></div>",
            nextArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-right-long'></i></div>",
            dots: false,
            appendArrows: $('.tcontrol-arrows'),
        });

    }
    

        




          $('.bio__open').bind('click', function(e){

             $(this).parent().parent().toggleClass('active');

             return false;

          });

          $('.bio__close').bind('click', function(e){

            $(this).parent().parent().parent().toggleClass('active');

            return false;
        
          });








})





document.addEventListener('DOMContentLoaded', function () {

    let currentDepth = 0;
    let hasSetup = false;

    function initNav() {

        // -- are we less than 1301px
        if( window.innerWidth > 1300 ) return;


        if (hasSetup) return;
        console.log( "init Nav" );
        setUpBackButtons();
        setUpClickHandlers();
        hasSetup = true;
    }

    const setUpClickHandlers = () => {
        let hasChild = document.querySelectorAll('.menu-item-has-children > a');

        hasChild.forEach(function (item) {
            item.addEventListener('click', function (event) {
                console.log('clicked');
                event.preventDefault();

                let parent = this.parentElement;
                let sub = parent.querySelector('.sub-menu');

                console.log(sub);
                sub.classList.add('active');
            });
        });
    };

    const setUpBackButtons = () => {
        let subs = document.querySelectorAll('.menu-item-has-children ul');

        subs.forEach(function (item) {

        
            let back = document.createElement('li');
            back.classList.add('back');
            back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
            item.insertBefore(back, item.firstChild);

            
            back.addEventListener('click', function (event) {
                event.preventDefault();
                this.parentElement.classList.remove('active');
            });
        });
    };

    if (window.innerWidth < 1300) {
        initNav();
    }

    // -- need a resize event to check if we need to re-init the nav
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1300 && !hasSetup) {
            initNav();
        }
    });

    // -- get all a tags in .nav if we are below 1300px
    if (window.innerWidth < 1300) {
        let links = document.querySelectorAll('.header .nav a');
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                // -- remove m-toggle class from body
                document.body.classList.remove('m-toggle');
            });
        });
    }

});




// -- [GLOBAL] on reszie get the header height and set it as a css var



const getHeaderHeight = () => {

    const header = document.querySelector('.header');

    // -- set timeout to allow for the header to render

    setTimeout(function() { 
    
        let headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');

    }, 1000);

};

document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

    // -- get the header height and assign it as a VAR
    getHeaderHeight();

    window.addEventListener('resize', function() {
            
            getHeaderHeight();
    
    });

});





   window.addEventListener('load', () => {

        initParallax();

      
    });
      


    window.addEventListener('resize', () => {

        initParallax();

    });

    let rellax;

    const initParallax = () => {

        // -- if the window is less than 1300px, do not init the parallax
        if (window.innerWidth < 1300) {
            // -- destroy the Rellax Instance
            rellax && rellax.destroy();
            rellax = null;
            destroyInertia();
        } else {
            // -- if we dont have a rellax instance
            if (!rellax) {
                // -- init the Rellax Instance
                rellax = new Rellax('.plaxElm');
                //doInertia();
            }
        }
        if( slickSlider ) {
            // timeout 
            setTimeout(() => {
                // -- if is a slick slider instnace
                if (slickSlider.hasClass('slick-initialized')) {
                    // -- destroy the slick slider
                    slickSlider.slick('refresh');
                }
            }, 5000);
        }

       

    }
 

   
function doInertia() {
    // from http://inertia-momentum-scroll.webflow.io/vanilla-js-version 
    // CJHersh https://webflow.com/CJHersh

    // -- add clas to body 
    document.body.classList.add('inertia-scroll');

    // First we get the elements we need, the body and our container on which
    // we are going to apply a smooth scroll. You will always need a container
    // to apply a smooth scroll. You will not be able to apply it directly to
    // the body.
    const body = document.body;
    const main = document.querySelector('main');

    // We define variables we will need later. 
    // 2 variables to store the scroll position and 2 variables to store the 
    // container position.
    let sx = 0;
    let sy = 0;

    let dx = sx;
    let dy = sy;

    // The trick is to set a height to the body to keep the browser scroll bar.
    body.style.height = main.clientHeight + 'px';

    // Then we fix our container so it won't move when the user scrolls.
    // We will move it ourself with the Linear Interpolation and translations.
    main.style.position = 'fixed';
    main.style.top = 0;
    main.style.left = 0;

    // We bind a scroll event to the window to watch scroll position.
    window.addEventListener('scroll', scroll);

    function scroll() {
    // We only update the scroll position variables
    sx = window.pageXOffset;
    sy = window.pageYOffset;
    }

    // Then we start a `requestAnimationFrame` loop. 

    window.requestAnimationFrame(render);

    function render() {
    // We calculate our container position by using our Linear Interpolation method.
    dx = lerp(dx, sx, 0.07);
    dy = lerp(dy, sy, 0.07);
    
    dx = Math.floor(dx * 100) / 100;
    dy = Math.floor(dy * 100) / 100;
    
    //console.log(dy);
    
    // Finally we translate our container to its new positions.
    // Don't forget to add a minus sign because the container needs to move in 
    // the opposite direction of the window scroll.
    main.style.transform = `translate(-${dx}px, -${dy}px)`;
    
    // And we loop again.
    window.requestAnimationFrame(render);
    }

    // This is our Linear Interpolation method.
    function lerp(a, b, n) {
    return (1 - n) * a + n * b;
    }
}


function destroyInertia() {
    // -- remove the scroll event listener
    window.removeEventListener('scroll', scroll);

    // -- remove the inertia-scroll class from the body
    document.body.classList.remove('inertia-scroll');
    
    // -- reset the main element styles
    const main = document.querySelector('main');
    main.style.position = '';
    main.style.top = '';
    main.style.left = '';
    main.style.transform = '';
    
    // -- reset the body height
    document.body.style.height = '';
    
   
}